import Typography from '@platform-ui-common/components/Typography/index.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import { FullWidthPanel } from '@platform-ui/application/components/index.js';
import { ReactNode } from 'react';

interface PanelProps {
  title: string;
  children: ReactNode;
}

export default function Panel({ title, children }: PanelProps): JSX.Element {
  return (
    <FullWidthPanel>
      <div className="w-full flex flex-col items-center">
        <div
          className={`lg:w-[28rem] py-6 px-8 flex flex-col gap-4 ${
            BackgroundColors[Color.LightBackground]
          }`}
        >
          <Typography variant="h2">{title}</Typography>
          {children}
        </div>
      </div>
    </FullWidthPanel>
  );
}
